// extracted by mini-css-extract-plugin
export default {"label":"DateTimePicker_label__dL3GJ","inputField":"DateTimePicker_inputField__xKo5L"};